// Célula de valor de entrega com edição inline: clique no valor → input.
// Enter ou clicar fora salva; Esc cancela. O botão de editar do bairro
// continua existindo pra editar nome/CEP — isto aqui acelera só o valor.
// Digitado de caixa registradora, como o resto (dono, 26/10/2026).

import { useEffect, useRef, useState } from "react";
import { Pencil } from "lucide-react";
import { InputDecimal } from "../../../components/ui/input-decimal";

export default function ValorEntregaCell({ bairro, onSalvar }) {
  const [editing, setEditing] = useState(false);
  const [valor, setValor] = useState("");
  const [saving, setSaving] = useState(false);
  const inputRef = useRef(null);
  const cancelRef = useRef(false);

  useEffect(() => {
    if (editing) inputRef.current?.focus();
  }, [editing]);

  const iniciar = () => {
    cancelRef.current = false;
    setValor(String(Number(bairro.valor_entrega) || 0));
    setEditing(true);
  };

  const finalizar = async () => {
    if (cancelRef.current) {
      cancelRef.current = false;
      setEditing(false);
      return;
    }
    const v = parseFloat(String(valor).replace(",", "."));
    const atual = Number(bairro.valor_entrega) || 0;
    if (isNaN(v) || v < 0 || Math.abs(v - atual) < 0.005) {
      setEditing(false);
      return;
    }
    setSaving(true);
    try {
      await onSalvar(bairro, v);
    } finally {
      setSaving(false);
      setEditing(false);
    }
  };

  if (editing) {
    return (
      <div className="relative inline-block">
        <span className="absolute left-2 top-1/2 -translate-y-1/2 text-xs text-muted-foreground z-10 pointer-events-none">
          R$
        </span>
        <InputDecimal
          ref={inputRef}
          data-e2e="bairro-valor-inline"
          decimals={2}
          value={valor}
          disabled={saving}
          onChange={setValor}
          onBlur={finalizar}
          onKeyDown={(e) => {
            if (e.key === "Enter") e.currentTarget.blur();
            if (e.key === "Escape") {
              cancelRef.current = true;
              e.currentTarget.blur();
            }
          }}
          className="w-28 h-8 pl-7 pr-2 text-sm font-bold"
        />
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={iniciar}
      title="Clique para editar o valor de entrega"
      className="group/valor inline-flex items-center gap-1.5 whitespace-nowrap rounded-md px-2 py-1 -mx-2 hover:bg-primary/10 transition-colors"
    >
      <span className="font-bold text-green-600 dark:text-green-500 tabular-nums">
        R$ {(Number(bairro.valor_entrega) || 0).toFixed(2).replace(".", ",")}
      </span>
      <Pencil className="hidden sm:block w-3 h-3 text-muted-foreground opacity-0 group-hover/valor:opacity-100 transition-opacity" />
    </button>
  );
}
